export { FreightSettingsPage } from './freight-settings-page';
export { FreightSettingsPage as default } from './freight-settings-page';
